import { Filters } from 'features/Filters/types/Filters';

const DELIMITER = ',';
const SEARCH_TERM = 'searchTerm';

export const emptyFilters: Filters = {
  environments: [],
  mediaOwnerNames: [],
  formatSizeNames: [],
  statuses: [],
  spaceIds: [],
};

export const toFilters = (searchParams: URLSearchParams): Filters => {
  const filters: Filters = { ...emptyFilters };
  Object.keys(filters).forEach((key) => {
    filters[key as keyof Filters] = searchParams.get(key)?.split(DELIMITER) || [];
  });
  return filters;
};

export const toFiltersSearchParams = (filters: Filters): URLSearchParams => {
  const params = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value && value.length) {
      params.set(key, value.join(DELIMITER));
    }
  });
  return params;
};

export const toSearchTerm = (searchParams: URLSearchParams): string => {
  return searchParams.get(SEARCH_TERM) ?? '';
};

export const toSearchTermSearchParams = (searchTerm: string): URLSearchParams => {
  const params = new URLSearchParams();
  params.append(SEARCH_TERM, searchTerm);
  return params;
};
